import { useState } from "react";
import { isMobile } from "react-device-detect";
import { handleShareFriendCode } from "../../lib/utils/shareFriendCode";
import { useT } from "../../i18n/LocaleContext";

function InviteButton({ code }) {
  const t = useT();
  const [isCopiedShown, setIsCopiedShown] = useState(false);

  const handleClick = () => {
    handleShareFriendCode(code);

    if (!isMobile) {
      setIsCopiedShown(true);
      setTimeout(() => {
        setIsCopiedShown(false);
      }, 3000);
    }
  };

  return (
    <button
      className="relative inline-flex items-center rounded-lg  bg-red-600 px-2 py-1 text-center text-xs font-medium text-white hover:bg-red-800 focus:outline-none focus:ring-4 focus:ring-red-200 dark:border-gray-700 dark:bg-gray-800 dark:text-white dark:hover:bg-gray-700 dark:focus:ring-gray-600"
      onClick={handleClick}
    >
      {isMobile ? (
        <svg
          aria-hidden="true"
          className="mr-1 h-4 w-4"
          viewBox="0 0 24 24"
          fill="white"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path fill="none" d="M0 0h24v24H0z" />
          <path d="M13 14h-2a8.999 8.999 0 00-7.968 4.81A10.136 10.136 0 013 18C3 12.477 7.477 8 13 8V3l10 8-10 8v-5z" />
        </svg>
      ) : (
        <svg
          aria-hidden="true"
          className="mr-1 h-4 w-4"
          viewBox="0 0 1024 1024"
          fill="white"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM382 896h-.2L232 746.2v-.2h150v150z" />
        </svg>
      )}

      {isMobile ? t("share.share") : t("share.copy")}

      <span
        className={`hidden transition-opacity duration-500 sm:block ${
          isCopiedShown ? "opacity-100" : "opacity-0"
        } absolute left-full translate-x-2 text-xs text-red-700`}
      >
        {t("share.copied")}
      </span>
    </button>
  );
}

export default InviteButton;
